import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import Container from "@/components/ContentContainer/Container";
import MoreButton from "@/components/MoreButton/MoreButton";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Skeleton from "@/components/Skeleton/Skeleton";
import StatusTag from "@/components/StatusTag/StatusTag";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { DeleteOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import DeleteMaterialAction from "../DeleteMaterialAction";
import { useGetMaterial } from "../useMaterials";
import styles from "./MaterialDetail.module.scss";
import MaterialDetails from "./MaterialDetails";
import MaterialImpact from "./MaterialImpact";
import MaterialRelations from "./MaterialRelations";
import MaterialUnitConversion from "./MaterialUnitConversion";

export default function MaterialDetail() {
  useTrackOnLoad("Material Viewed");

  const { materialId: id } = useParams();
  const materialId = Number(id);
  const navigate = useNavigate();

  const { data: material, isLoading, isFetching } = useGetMaterial({ materialId });

  return (
    <Flex
      gap={8}
      vertical
    >
      <PageHeader
        loading={isLoading}
        title={material?.name}
        right={
          <>
            {isLoading ? (
              <>
                <Skeleton style={{ width: "90px", height: "24px" }} />
                <Skeleton style={{ width: "24px", height: "24px" }} />
              </>
            ) : (
              <>
                {material && (
                  <>
                    {isFetching ? (
                      <Skeleton style={{ width: "90px", height: "24px" }} />
                    ) : (
                      <StatusTag
                        background="white"
                        status={material.status}
                        showIcon={false}
                      />
                    )}

                    <MoreButton
                      actions={
                        <>
                          <DeleteMaterialAction
                            materials={[material]}
                            onSucces={() => navigate("/matching/materials")}
                          >
                            <>
                              <ActionsPopOverItem
                                disabled={material.relations > 0}
                                danger
                                icon={<DeleteOutlined />}
                              >
                                Delete material
                              </ActionsPopOverItem>
                            </>
                          </DeleteMaterialAction>
                        </>
                      }
                    />
                  </>
                )}
              </>
            )}
          </>
        }
      />
      <Flex>
        <Container
          padding={false}
          className={styles.MaterialDetail}
        >
          <MaterialImpact materialId={materialId} />
          <MaterialUnitConversion materialId={materialId} />
          <MaterialRelations materialId={materialId} />
        </Container>
        <MaterialDetails materialId={materialId} />
      </Flex>
    </Flex>
  );
}
